var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block-header"},[_c('div',[_c('h2',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-juxing"}})])]),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }